import React from 'react';

const UxUiDesign = () => {
  return (
    <div className="skills__content">
      <h3 className="skills__title">UX-UI Designer / Backend developer</h3>
      <div className="skills__box">
        <div className="skills__group">
          <div className="skills__data">
            <i class="bx bx-badge-check"></i>
            <div>
              <h3 className="skills__name">Figma</h3>
              <span className="skills__level">Средний</span>
            </div>
          </div>
          <div className="skills__data">
            <i class="bx bx-badge-check"></i>
            <div>
              <h3 className="skills__name">Photoshop</h3>
              <span className="skills__level">Средний</span>
            </div>
          </div>
        </div>

        <div className="skills__group">
          <div className="skills__data">
            <i class="bx bx-badge-check"></i>
            <div>
              <h3 className="skills__name">Python</h3>
              <span className="skills__level">База</span>
            </div>
          </div>
          <div className="skills__data">
            <i class="bx bx-badge-check"></i>
            <div>
              <h3 className="skills__name">Node JS</h3>
              <span className="skills__level">База</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UxUiDesign;
